import React from "react";

/**
 * Sidebar Page component - represents a single page/tab in a multi-page sidebar
 * Similar to WizardView.Page
 *
 * @param {string} name - Unique identifier for the page
 * @param {string} title - Display title for the tab (defaults to name if not provided)
 * @param {React.ReactNode} children - Page content
 */
const Page = ({ name, title, children }) => {
    return (
        <div className="sidebar-page" data-page-name={name}>
            {children}
        </div>
    );
};

export default Page;
